import { notifications } from '@mantine/notifications';
import { userFacingMessage } from '@/shared/api/errorMessage';

/**
 * Il testo di una notifica d'errore. La regola sta tutta in `userFacingMessage()`: `meta.code`
 * del BE se c'è, frase in italiano se la risposta non è arrivata, `message` come ultima spiaggia.
 */
export function getErrorMessage(err: unknown): string {
  return userFacingMessage(err, 'Errore');
}

export function notifySuccess(message: string, title?: string): void {
  notifications.show({ color: 'green', message, title });
}

export function notifyError(err: unknown, title = 'Errore'): void {
  notifications.show({ color: 'red', title, message: getErrorMessage(err) });
}

export function notifyInfo(message: string, title?: string): void {
  notifications.show({ color: 'blue', message, title });
}

export function notifyWarn(message: string, title?: string): void {
  notifications.show({ color: 'yellow', message, title });
}
